module.exports = __webpack_public_path__ + "img/tryb.7da5afda.png";